import {TFunction} from 'i18next';

import {TRANSLATION_KEYS} from 'locale';
import {ComplianceAuditFilters, ComplianceAuditMessage, ComplianceMessageAuthor, UserSummary} from 'types';
import {findUserName} from 'utils/transform';

import {REQUEST_SESSION_HISTORY_DATE_FORMAT} from '../constants';
import {ActivityFilters} from '../types';

const toComplianceAuditFilters = (filters: ActivityFilters): ComplianceAuditFilters => ({
    startDate: filters.startDate?.format(REQUEST_SESSION_HISTORY_DATE_FORMAT),
    endDate: filters.endDate?.format(REQUEST_SESSION_HISTORY_DATE_FORMAT),
    eid: filters.eid || undefined,
    groupId: filters.groupId || undefined,
    subgroupId: filters.subgroupId || undefined,
    sessionId: filters.sessionId?.trim() || undefined
});

const getAgentName = (t: TFunction, users: UserSummary[], eid: number, fallback: string): string =>
    findUserName(t, users, {eid}) || fallback;

const getParticipantName = (t: TFunction, users: UserSummary[], message: ComplianceAuditMessage): string =>
    message.author === ComplianceMessageAuthor.Bot
        ? t(TRANSLATION_KEYS.USER.ACTIVITY.COMPLIANCE.CHATBOT)
        : findUserName(t, users, {eid: message.agentEid}) || message.agentEmail || '';

export const complianceUtils = {
    toComplianceAuditFilters,
    getAgentName,
    getParticipantName
};
